var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4605 5.2C9.71053 4.5818 9.67105 3.4898 9.67105 3.4898V0H1.97368C1.45023 0 0.948216 0.210714 0.578079 0.585786C0.207941 0.960859 0 1.46957 0 2L0 18C0 18.5304 0.207941 19.0391 0.578079 19.4142C0.948216 19.7893 1.45023 20 1.97368 20H13.0263C13.5498 20 14.0518 19.7893 14.4219 19.4142C14.7921 19.0391 15 18.5304 15 18V5.8H12.4575C12.4575 5.8 11.2105 5.8182 10.4605 5.2Z",
    fill: "#025E86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6575 0V3.2C10.6575 3.2 10.5961 4.7882 12.0391 4.8C13.4821 4.8118 14.9996 4.8 14.9996 4.8L10.6575 0Z",
    fill: "#025E86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1645 6.79999H2.46712C2.19461 6.79999 1.97369 7.02385 1.97369 7.29999C1.97369 7.57613 2.19461 7.79999 2.46712 7.79999H10.1645C10.437 7.79999 10.6579 7.57613 10.6579 7.29999C10.6579 7.02385 10.437 6.79999 10.1645 6.79999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3983 9.59998H2.60168C2.25485 9.59998 1.97369 9.82383 1.97369 10.1C1.97369 10.3761 2.25485 10.6 2.60168 10.6H12.3983C12.7452 10.6 13.0263 10.3761 13.0263 10.1C13.0263 9.82383 12.7452 9.59998 12.3983 9.59998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/Document_Icon.1aab73cccf1589407c7a8e90ac224b7a.svg";
export { ForwardRef as ReactComponent };